import React from "react";
import Header from "components/Header";
import Utils from "utils";
export default function MoreInfoMainView(props) {
  const { intl, productInfo, history } = props;
  return (
    <div className="moreInfo-container">
      <Header
        headerTitle={intl.messages.Effect}
        isWhite={false}
        onPress={() =>
          Utils.onBackProductDiscovery(history, productInfo.qr_code)
        }
      />
      <ul className="content">
        {productInfo?.description.split("\n").map((str) => (
          <li className="moreInfo-paragraph">{str}</li>
        ))}
      </ul>
    </div>
  );
}
